import React from "react";

const Footer = () => {
  return (
    <div>
      <footer className=" mt-5">
        <div className="container mt-5">
          <div className="row mt-5">
            <div className="col-md-12 fs-3">
              <small>Created by Idowu ariyo</small>&nbsp;
              <a href="/">
                <span className="fab fa-linkedin"></span>
              </a> &nbsp;
              <a href="/">
                <span className='fab fa-github-square'></span>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
